import { useStyles } from "./IssueDueDateCell.styles";
import { IIssueDueDateCell } from "./IssueDueDateCellInterfaces";
import { useMemo } from "react";
import MainTag from "components/MainTag";
import { MainTagTypeEnum } from "components/MainTag/MainTagInterfaces";
import { useTranslation } from "react-i18next";
import { RCA_STATUSES } from "constants/constants";
import { isLate } from "utilities/utilities";
import useDateFormat from "hooks/useDateFormat";

const IssueDueDateCell = ({ issue }: IIssueDueDateCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { formatDate} = useDateFormat();

    const showLateTag = useMemo(() => {
        return isLate(new Date(issue.due_date).toISOString()) && issue.status.status_id !== RCA_STATUSES.COMPLETED;
    }, [issue.due_date, issue.status.status_id]);

    return (
        <div className={`${classes.descriptionWrapper} ${showLateTag ? classes.textRed : ""}`}>
            <span>{formatDate(issue.due_date)}</span>
            {showLateTag && <MainTag type={MainTagTypeEnum.ERROR}>{t("rca.issues.late")}</MainTag>}
        </div>
    );
};

export default IssueDueDateCell;
